import PropTypes from 'prop-types';

const TaskListSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 60}`}
      height={`${height || 60}`}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#clip0_50_8560${width + height})`}>
        <path
          d="M41.6016 60H1.75781C0.787031 60 0 59.213 0 58.2422V1.75781C0 0.787031 0.787031 0 1.75781 0H41.6016C42.5723 0 43.3594 0.787031 43.3594 1.75781V58.2422C43.3594 59.213 42.5723 60 41.6016 60ZM50.625 12.3047V47.6953H60V12.3047H50.625Z"
          fill={`url(#paint0_linear_50_8560${width + height})`}
        />
        <path
          d="M28.7109 10.7813H14.6484C13.6777 10.7813 12.8906 9.99422 12.8906 9.02344C12.8906 8.05266 13.6777 7.26563 14.6484 7.26563H28.7109C29.6817 7.26563 30.4688 8.05266 30.4688 9.02344C30.4688 9.99422 29.6817 10.7813 28.7109 10.7813ZM18.75 16.0547C18.75 15.0839 17.963 14.2969 16.9922 14.2969H7.61719C6.64641 14.2969 5.85938 15.0839 5.85938 16.0547C5.85938 17.0255 6.64641 17.8125 7.61719 17.8125H16.9922C17.963 17.8125 18.75 17.0255 18.75 16.0547ZM18.75 23.0859C18.75 22.1152 17.963 21.3281 16.9922 21.3281H7.61719C6.64641 21.3281 5.85938 22.1152 5.85938 23.0859C5.85938 24.0567 6.64641 24.8438 7.61719 24.8438H16.9922C17.963 24.8438 18.75 24.0567 18.75 23.0859ZM18.75 30.1172C18.75 29.1464 17.963 28.3594 16.9922 28.3594H7.61719C6.64641 28.3594 5.85938 29.1464 5.85938 30.1172C5.85938 31.088 6.64641 31.875 7.61719 31.875H16.9922C17.963 31.875 18.75 31.088 18.75 30.1172ZM18.75 37.1484C18.75 36.1777 17.963 35.3906 16.9922 35.3906H7.61719C6.64641 35.3906 5.85938 36.1777 5.85938 37.1484C5.85938 38.1192 6.64641 38.9063 7.61719 38.9063H16.9922C17.963 38.9063 18.75 38.1192 18.75 37.1484ZM18.75 44.1797C18.75 43.2089 17.963 42.4219 16.9922 42.4219H7.61719C6.64641 42.4219 5.85938 43.2089 5.85938 44.1797C5.85938 45.1505 6.64641 45.9375 7.61719 45.9375H16.9922C17.963 45.9375 18.75 45.1505 18.75 44.1797ZM18.75 51.2109C18.75 50.2402 17.963 49.4531 16.9922 49.4531H7.61719C6.64641 49.4531 5.85938 50.2402 5.85938 51.2109C5.85938 52.1817 6.64641 52.9688 7.61719 52.9688H16.9922C17.963 52.9688 18.75 52.1817 18.75 51.2109ZM57.0703 0H53.5547C51.9367 0 50.625 1.31168 50.625 2.92969V12.3047H60V2.92969C60 1.31168 58.6883 0 57.0703 0ZM50.625 47.6953C50.625 47.8543 50.6466 48.0127 50.6891 48.1658L53.6188 58.7127C54.0956 60.4291 56.5294 60.4291 57.0062 58.7127L59.9359 48.1658C59.9784 48.0127 60 47.8543 60 47.6953H50.625ZM29.9539 52.4539L36.9852 45.4227C37.6717 44.7362 37.6717 43.6233 36.9852 42.9368C36.2987 42.2503 35.1858 42.2503 34.4993 42.9368L28.7109 48.725L27.0537 47.0678C26.3672 46.3813 25.2543 46.3813 24.5678 47.0678C23.8813 47.7543 23.8813 48.8672 24.5678 49.5537L27.468 52.4539C28.1544 53.1403 29.2675 53.1403 29.9539 52.4539ZM29.9539 38.3914L36.9852 31.3602C37.6717 30.6737 37.6717 29.5608 36.9852 28.8743C36.2987 28.1878 35.1858 28.1878 34.4993 28.8743L28.7109 34.6625L27.0537 33.0053C26.3672 32.3188 25.2543 32.3188 24.5678 33.0053C23.8813 33.6918 23.8813 34.8047 24.5678 35.4912L27.468 38.3914C28.1544 39.0778 29.2675 39.0778 29.9539 38.3914ZM29.9539 24.3289L36.9852 17.2977C37.6717 16.6112 37.6717 15.4983 36.9852 14.8118C36.2987 14.1253 35.1858 14.1253 34.4993 14.8118L28.7109 20.6L27.0537 18.9428C26.3672 18.2563 25.2543 18.2563 24.5678 18.9428C23.8813 19.6293 23.8813 20.7422 24.5678 21.4287L27.468 24.3289C28.1544 25.0153 29.2675 25.0153 29.9539 24.3289Z"
          fill={`url(#paint1_linear_50_8560${width + height})`}
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_50_8560${width + height}`}
          x1="30"
          y1="60"
          x2="30"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_50_8560${width + height}`}
          x1="32.9297"
          y1="60"
          x2="32.9297"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <clipPath id={`clip0_50_8560${width + height}`}>
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

TaskListSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default TaskListSvg;
